// Router + QueryClient (T01 §9.15). routeTree.gen.ts is generated by @tanstack/router-plugin on
// `vite dev`/`vite build`; never edit it and never import it anywhere else.
import { createRouter } from "@tanstack/react-router";
import { QueryClient } from "@tanstack/react-query";
import { routeTree } from "../routeTree.gen";
import { reportNavigation } from "../telemetry";

export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000 } },
});

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  scrollRestoration: true,
});

// One "navigation" span + log record per route change (T7 frontend interaction telemetry).
router.subscribe("onResolved", ({ toLocation }) => reportNavigation(toLocation.pathname));

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
